@if (isLoading) {
<app-loader class="centerLoader pt-5"></app-loader>
}

@if (!isLoading) {
<div class="deviations-container">
  @if (!hasData) {
  <div class="no-data">
    <mat-icon class="no-data-icon">bar_chart</mat-icon>
    <h3 class="no-data-title">{{ variables.noDeviationData || 'Sin datos de desviación' }}</h3>
    <p class="no-data-desc">{{ variables.noDeviationDataDesc || 'Primero debes guardar la imputación real para poder
      analizar las desviaciones.' }}</p>
  </div>
  }
  @if (hasData) {
  <div class="container mb-5">
    <div class="top">
      <div style="width: 100%;">
        <p class="subtitle">{{ variables.deviationSubtitle || 'Informe comparativo entre estimaciones y horas
          reales imputadas' }}</p>
      </div>
    </div>
    <hr>
    <!-- Summary Cards -->
    <div class="summary-cards">
      <div class="summary-card card-estimated">
        <div class="card-label">{{ variables.totalEstimated || 'Total Estimado' }}</div>
        <div class="card-value">{{ totalEstimated | number:'1.0-1' }}h</div>
      </div>
      <div class="summary-card card-actual">
        <div class="card-label">{{ variables.totalActual || 'Total Real' }}</div>
        <div class="card-value">{{ totalActual | number:'1.0-1' }}h</div>
      </div>
      <div class="summary-card card-deviation">
        <div class="card-label">{{ variables.deviation || 'Desviación' }}</div>
        <div class="card-value" [ngClass]="{'negative-diff': totalDeviation > 0, 'positive-diff': totalDeviation < 0}">
          <span class="deviation-icon">📈</span>
          {{ totalDeviation > 0 ? '+' : '' }}{{ totalDeviation | number:'1.0-1' }}h
        </div>
      </div>
      <div class="summary-card card-percent">
        <div class="card-label">{{ variables.deviationPercent || 'Desviación %' }}</div>
        <div class="card-value"
          [ngClass]="{'negative-diff': totalDeviationPercent > 0, 'positive-diff': totalDeviationPercent < 0}">
          {{ totalDeviationPercent > 0 ? '+' : '' }}{{ totalDeviationPercent }}%
        </div>
      </div>
    </div>
    <!-- Bar Chart: Estimated vs Actual by Section -->
    <div class="chart-panel">
      <h5 class="panel-title">{{ variables.comparisonChart || 'Comparación: Horas Estimadas vs Reales por Sección'
        }}</h5>
      <div class="chart-container">
        <canvas id="barChart"></canvas>
      </div>
    </div>
    <!-- Pie chart + Deviations by Section (side by side) -->
    <div class="charts-row">
      <div class="chart-panel half-panel">
        <h5 class="panel-title">{{ variables.distributionChart || 'Distribución Total: Estimado vs Real' }}</h5>
        <div class="chart-container pie-container">
          <canvas id="pieChart"></canvas>
        </div>
      </div>
      <div class="chart-panel half-panel">
        <h5 class="panel-title">{{ variables.deviationsBySection || 'Desviaciones por Sección' }}</h5>
        <table class="deviation-summary-table">
          <thead>
            <tr>
              <th class="text-left">{{ variables.sectionLabel || 'Sección' }}</th>
              <th class="text-right">{{ variables.deviationHours || 'Desv. (h)' }}</th>
              <th class="text-right">{{ variables.deviationPercentLabel || 'Desv. %' }}</th>
            </tr>
          </thead>
          <tbody>
            @for (section of sectionSummaries; track section) {
            <tr>
              <td>{{ section.name }}</td>
              <td class="text-right"
                [ngClass]="{'negative-diff': section.deviation > 0, 'positive-diff': section.deviation < 0}">
                {{ section.deviation > 0 ? '+' : '' }}{{ section.deviation | number:'1.1-1' }}
              </td>
              <td class="text-right"
                [ngClass]="{'negative-diff': section.deviationPercent > 0, 'positive-diff': section.deviationPercent < 0}">
                {{ section.deviationPercent > 0 ? '+' : '' }}{{ section.deviationPercent |
                number:'1.1-1' }}%
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
    <!-- Tasks with highest deviation -->
    @if (topDeviationRows.length > 0) {
    <div class="chart-panel">
      <h5 class="panel-title warning-title">
        <mat-icon class="warning-icon">warning</mat-icon>
        {{ variables.tasksHighestDeviation || 'Tareas con Mayor Desviación' }}
      </h5>
      <table class="deviation-detail-table">
        <thead>
          <tr>
            <th class="text-left col-task">{{ variables.taskLabel || 'Tarea' }}</th>
            <th class="text-right col-hours">{{ variables.estimatedLabel || 'Estimadas' }}</th>
            <th class="text-right col-hours">{{ variables.actualLabel || 'Reales' }}</th>
            <th class="text-right col-hours">{{ variables.deviationHours || 'Desviación (h)' }}</th>
            <th class="text-right col-pct">{{ variables.deviationPercentLabel || 'Desviación %' }}</th>
          </tr>
        </thead>
        <tbody>
          @for (row of topDeviationRows; track row) {
          <tr>
            <td class="col-task">{{ row.sectionType }} - {{ row.sectionName }}</td>
            <td class="text-right col-hours">{{ row.estimatedHours | number:'1.0-1' }}h</td>
            <td class="text-right col-hours">{{ row.actualHours | number:'1.0-1' }}h</td>
            <td class="text-right col-hours"
              [ngClass]="{'negative-diff': row.deviation > 0, 'positive-diff': row.deviation < 0}">
              {{ row.deviation > 0 ? '+' : '' }}{{ row.deviation | number:'1.1-1' }}h
            </td>
            <td class="text-right col-pct"
              [ngClass]="{'negative-diff': row.deviationPercent > 0, 'positive-diff': row.deviationPercent < 0}">
              {{ row.deviationPercent > 0 ? '+' : '' }}{{ row.deviationPercent | number:'1.1-1' }}%
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
    <!-- Conclusions -->
    <div class="conclusions-panel">
      <h5 class="panel-title conclusions-title">{{ variables.conclusions || 'Conclusiones' }}</h5>
      @for (conclusion of conclusions; track conclusion) {
      <div class="conclusion-item">
        <span class="conclusion-icon">{{ conclusion.icon }}</span>
        <span>{{ conclusion.text }}</span>
      </div>
      }
    </div>
    <!-- Export -->
    <div class="estimate-result-export mt-3">
      <app-button typeBtn="secondary" style="display: flex; position: relative;" (click)="exportFullReport()"
        [message]="isExporting ? (variables.exporting || 'Exportando...') : (variables.exportFullReport || 'Exportar Informe Completo')"
        mat-icon-button [matTooltip]="variables.exportFullReport || 'Exportar Informe Completo'"
        icon="../../../../../assets/images/excel.svg" iconPosition='left' [addIconClasses]="false" width='250px'>
      </app-button>
    </div>
  </div>
  }
</div>
}